"use client";
import { SpaceSm, SpaceMd, FontLineHeightSm, FontSize400, ColorTextDefault, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
const overLayStyles = {
  alignItems: "center",
  backgroundColor: "rgb(249 249 249 / 41%)",
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  left: 0,
  position: "absolute",
  right: 0,
  top: 0
};
const overlayTextStyles = {
  background: ColorWhite,
  color: ColorTextDefault,
  fontSize: FontSize400,
  lineHeight: FontLineHeightSm,
  padding: `${SpaceSm} ${SpaceMd}`,
  textAlign: "center",
  width: "100%"
};
const containerStyles = {
  display: "block",
  position: "relative"
};
export {
  containerStyles,
  overLayStyles,
  overlayTextStyles
};
